// extracted by mini-css-extract-plugin
module.exports = {"heading":"Form_heading__OQ6hV","submit":"Form_submit__258W4"};